import {Expose, Type} from 'class-transformer';
import {EventParticipationRequestVehicleApiModel} from './event-participation-request-vehicle.api-model';

export class EventParticipationRequestApiModel {
  @Expose() public id: number;
  @Expose() public status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
  @Expose() public rejectionReason?: string | null;
  @Expose() public submittedAt?: Date;
  @Expose() public decidedAt?: Date | null;
  @Expose()
  @Type(() => EventParticipationRequestVehicleApiModel)
  public vehicles: EventParticipationRequestVehicleApiModel[];
  @Expose() public declaration?: any;
}

